import { doc, updateDoc, getDoc } from "firebase/firestore";
import { db } from "config/firebase";
import { storage } from "config/firebase";
import { ref, deleteObject } from "@firebase/storage";
import { Attachment } from "@freetech/models";

/**
 * Removes an attachment from a feature request and deletes it from storage
 * @param clientId The ID of the client
 * @param featureRequestId The ID of the feature request
 * @param attachmentId The ID of the attachment to remove
 */
export const removeFeatureRequestAttachment = async (
  clientId: string,
  featureRequestId: string,
  attachmentId: string
): Promise<void> => {
  try {
    const featureRequestRef = doc(
      db,
      "clients",
      clientId,
      "featureRequests",
      featureRequestId
    );


    const featureRequestDoc = await getDoc(featureRequestRef);
    if (!featureRequestDoc.exists()) {
      throw new Error("Feature request not found");
    }

    const currentAttachments = featureRequestDoc.data()?.attachments || [];


    const attachmentToRemove = currentAttachments.find(
      (attachment: Attachment) => attachment.id === attachmentId
    );

    if (!attachmentToRemove) {
      throw new Error("Attachment not found");
    }


    try {

      const fileName = attachmentToRemove.name;
      const storageRef = ref(
        storage,
        `featureRequests/${clientId}/${featureRequestId}/${fileName}`
      );
      await deleteObject(storageRef);
    } catch (error) {
      console.error("Error deleting file from storage:", error);

    }


    const updatedAttachments = currentAttachments.filter(
      (attachment: Attachment) => attachment.id !== attachmentId
    );


    await updateDoc(featureRequestRef, {
      attachments: updatedAttachments,
      updatedAt: new Date().toISOString(),
    });
  } catch (error) {
    console.error("Error removing attachment:", error);
    throw error;
  }
};
